import { render, staticRenderFns } from "./sys.vue?vue&type=template&id=d1bdbfa2&scoped=true&"
import script from "./sys.vue?vue&type=script&lang=ts&"
export * from "./sys.vue?vue&type=script&lang=ts&"
import style0 from "./sys.vue?vue&type=style&index=0&id=d1bdbfa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bdbfa2",
  null
  
)

export default component.exports